import { CreateComponent } from "./Create";
import { EditComponent } from "./Edit";
import { ListComponent } from "./List";
import { ShowComponent } from "./Show";

const components = {
  list: ListComponent,
  show: ShowComponent,
  edit: EditComponent,
  create: CreateComponent,
};

export default components;
